import './style/productsMoved.scss';
import React from 'react';
import {useTranslation} from 'react-i18next';
import {AwesomeIcon, ElementPosition} from '@dvrd/dvr-controls';
import {BluemateButton, BluemateEmptyState} from '../../controls';

interface Props {
    onClickGoToProducts: VoidFunction;
}

export default function ProductsMoved(props: Props) {
    const {onClickGoToProducts} = props;
    const {t} = useTranslation();

    return (
        <div className='products-moved'>
            <BluemateEmptyState
                image='data-rows'
                title={t('settings.productsMoved.title', 'Productinstellingen zijn verhuisd')}
            >
                <p>
                    {t(
                        'settings.productsMoved.body',
                        'Je vindt je productinstellingen (naam, BTW, kosten, QR-codes en zichtbaarheid) voortaan op de pagina Producten.'
                    )}
                </p>
                <BluemateButton
                    label={t('settings.productsMoved.button', 'Ga naar Producten')}
                    onClick={onClickGoToProducts}
                    ornaments={{element: <AwesomeIcon name='arrow-right' />, placement: ElementPosition.RIGHT}}
                    align='center'
                />
            </BluemateEmptyState>
        </div>
    );
}
